/* eslint-disable indent */
export default class Page {
    constructor () {
        this.picture = ''
        this.caption = ''
        this.nextCaption = ''
        this.previousSentence = ''
        this.generatedSentences = []
        this.allImages = []
        this.selectedImage = -1
    }
}



// WEBPACK FOOTER //
// ./src/Page.js